//@ts-nocheck
import { initGlobalTracer } from 'opentracing';
import * as lightstepTracer from 'lightstep-tracer';
import config from '../config';

export function initTracer(): void {
  const lightstepTracerOptions: lightstepTracer.TracerOptions = {
      access_token: 'developer',
      component_name: 'Presto UI',
      collector_host: config.REACT_APP_LIGHTSTEP_HOST,
      collector_port: +config.REACT_APP_LIGHTSTEP_PORT,
      collector_encryption: config.REACT_APP_LIGHTSTEP_ENCRYPTION,
    };

    initGlobalTracer(new lightstepTracer.Tracer(lightstepTracerOptions));
  }


